const secsToMinsString = (secs) => {
  const date = new Date(secs * 1000);
  const paddedSecs = `${date.getUTCSeconds()}`.padStart(2, '0');

  return `${date.getUTCMinutes()}:${paddedSecs}`;
};

export default secsToMinsString;
